import { styled, Stack } from "@mui/material";

export const StyledContainer = styled(Stack)(({ theme }) => ({
  flexDirection: "column",
  alignItems: "stretch",
  gap: "24px",
  maxWidth: "1200px",
  margin: "0 auto",

  [theme.breakpoints.down("desktop")]: {
    padding: "16px",
    gap: "16px",
  },
}));
